import { Flex, Text } from '@pega/cosmos-react-core';

export const FraudRiskRenderer = () => {
  return (
    <Flex container={{ direction: 'column', gap: 2 }}>
      <Flex container={{ direction: 'column', gap: 0.5 }}>
        <Text variant='secondary'>Fraud risk</Text>
        <Text variant='h3'>76%</Text>
      </Flex>
      <Text variant='secondary'>65% average</Text>
      <Text as='p'>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
        laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
        voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
        cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
      </Text>
    </Flex>
  );
};
